import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Alert, AlertService } from '@michelin/theme';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';

@Component({
    selector: 'app-import-automaker-orders',
    templateUrl: './import-automaker-orders.component.html',
    standalone: false
})
export class ImportAutomakerOrdersComponent implements OnInit {
  loading = false;
  automakerId: number;
  automaker: AutomakerDto;
  selectedFiles: FileList;
  form: FormGroup;
  errorMessage: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private readonly automakerService: AutomakerService,
    private readonly alertService: AlertService
  ) {
    this.form = this.formBuilder.group({
      file: [null, Validators.required]
    });
  }

  selectFile(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedFiles = input.files;
    if (this.selectedFiles) {
      this.form.patchValue({ file: this.selectedFiles.item(0) });
    }
  }

  submitForm() {
    this.errorMessage = null;
    this.loading = true;
    this.automakerService
      .uploadOrders(this.automakerId, this.selectedFiles.item(0))
      .subscribe({
        next: () => this.alertService.showAlert({ type: 'success', title: 'Arquivo carregado com sucesso' } as Alert),
        error: (errorResponse: any) => {
          this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao carregar o arquivo' } as Alert);
          if (errorResponse.error && errorResponse.error.message) {
            this.errorMessage = errorResponse.error.message;
          }
        }
      })
      .add(() => (this.loading = false));
  }

  ngOnInit() {
    this.loading = true;
    this.automakerId = this.activatedRoute.snapshot.params['id'];
    this.automakerService
      .findById(this.automakerId)
      .subscribe({
        next: (result) => (this.automaker = result),
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao recuperar as informações' } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
